// extracted by mini-css-extract-plugin
module.exports = {"sider-trigger":"style_sider-trigger__3Ul_Q","button-container":"style_button-container__3eZoX"};